var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{attrs:{"table-ref":"landlordstable","title":"Landlords","icon":"fa fa-house","url":"report/property/landlords","fields":_vm.fields,"sort-field":"name","search-placeholder":"Search Landlords...","layer-component":"propertyLandlord","layer-args":{ id: 'id' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }